(ns frontend.test-ribbon.event
  (:require
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.local-storage :as ls]
   [frontend.test-ribbon.model :as model]
   [oops.core :as oops]
   [potpuri.core :as p]
   [re-frame.core :as rf]
   [ui.state.session.model :as session-model]
   [ui.view.nev.event :as nev-event]))

(defn inject-entities-cofx
  [cofx _]
  (let [db (:db cofx)
        entities (session-model/get-entities db)]
    (assoc cofx :entities entities)))

(def ribbon-id-ls-key :current-ribbon-id)

(defn ->tab-id-ls-key
  [ribbon-id]
  [:ribbon-current-tab ribbon-id])

(def save-ribbon-id-to-localstorage
  (rf/after
   (fn [db]
     (let [ribbon-id (get-in db model/ribbon-id-full-path)]
       (ls/set ribbon-id-ls-key ribbon-id)))))

(rf/reg-cofx
 ::get-ribbon-id-from-localstorage
 (fn [cofx]
   (assoc cofx
     :ribbon-id (ls/get ribbon-id-ls-key)
     :current-tabs-by-ribbon-id (ls/get-in [:ribbon-current-tab]))))

(def save-tab-id-to-localstorage
  (rf/after
   (fn [db]
     (let [ribbon-id (get-in db model/ribbon-id-full-path)
           tab-id (get-in db model/tab-id-full-path)]
       (ls/set-in (->tab-id-ls-key ribbon-id) tab-id)))))

(rf/reg-cofx
 ::get-tab-id-from-localstorage
 (fn [{:keys [ribbon-id] :as cofx}]
   (if ribbon-id
     (assoc cofx :tab-id (ls/get-in (->tab-id-ls-key ribbon-id)))
     (do
       (js/console.warn "Ribbon id not found from cofx")
       cofx))))

(defn inject-ribbon-and-tab-cofx
  [cofx _]
  (let [db (:db cofx)
        entities (session-model/get-entities db)
        tab-id (get-in db model/tab-id-full-path)
        tab (get entities tab-id)
        ribbon-id (get-in db model/ribbon-id-full-path)
        ribbon (get entities ribbon-id)]
    (-> cofx
        (assoc :tab-id tab-id)
        (assoc :tab tab)
        (assoc :ribbon-id ribbon-id)
        (assoc :ribbon ribbon))))

(rf/reg-cofx ::inject-entities inject-entities-cofx)
(rf/reg-cofx ::inject-ribbon-and-tab inject-ribbon-and-tab-cofx)

(defn inject-entities
  []
  (rf/inject-cofx ::inject-entities))

(defn inject-ribbon-and-tab
  []
  (rf/inject-cofx ::inject-ribbon-and-tab))

(rf/reg-event-fx
 ::init!
 [(inject-entities)
  rf/trim-v
  (rf/inject-cofx ::get-ribbon-id-from-localstorage)
  (rf/inject-cofx ::get-tab-id-from-localstorage)]
 (fn [{:keys [db entities ribbon-id tab-id]}]
   (let [tab (get entities tab-id)
         viewed-entity-id (:tab/viewed-entity tab)
         view-id (:tab/current-view tab)
         view (get entities view-id)
         nev? (= (:view/type view) :view.type/single-entity)
         new-db (-> db
                    (assoc-in model/ribbon-id-full-path ribbon-id)
                    (assoc-in model/tab-id-full-path tab-id))]
     (merge
      {:db new-db}
      (when nev?
        {:fx [[:dispatch [::nev-event/open-view
                          {:view-id   view-id
                           :entity-id viewed-entity-id}]]]})))))

(def standard-intercept
  [rf/trim-v
   (inject-entities)
   (inject-ribbon-and-tab)])

(rf/reg-event-fx
 ::open-tab
 [rf/trim-v
  (inject-entities)
  (inject-ribbon-and-tab)
  save-tab-id-to-localstorage]
 (fn [{:keys [db entities ribbon ribbon-id tab tab-id]}
      [opened-tab-id]]
   (let [tab (get entities opened-tab-id)
         viewed-entity-id (:tab/viewed-entity tab)
         view-id (:tab/current-view tab)
         view (get entities view-id)
         nev? (= :view.type/single-entity
                 (:view/type view))
         new-db (-> db
                    (assoc-in model/tab-id-full-path opened-tab-id))]
     (merge
      {:db new-db}
      (when nev?
        {:fx [[:dispatch [::nev-event/open-view
                          {:view-id   view-id
                           :entity-id viewed-entity-id}]]]})))))

(rf/reg-event-fx
 ::duplicate-tab
 [standard-intercept]
 (fn [{:keys [db entities ribbon ribbon-id tab tab-id]}
      [duplicated-tab-id]]
   (let [tab (get entities duplicated-tab-id)
         viewed-entity (:tab/viewed-entity tab)
         view-id (:tab/current-view tab)]
     {:db       db
      ::ws/send {:id         :entity/create-entity
                 :body       {:entity/type       :entity.type/tab
                              :tab/viewed-entity viewed-entity
                              :tab/ribbon        ribbon-id
                              :tab/current-view  view-id
                              :common/ord        (+ (:common/ord tab) 0.001)}
                 :on-success [::create-tab-success]
                 :on-error   [::create-tab-error]}})))

(rf/reg-event-fx
 ::open-ribbon
 [(inject-entities)
  rf/trim-v
  (rf/inject-cofx ::get-ribbon-id-from-localstorage)
  save-ribbon-id-to-localstorage]
 (fn [{:keys [db entities current-tabs-by-ribbon-id]}
      [new-ribbon-id]]
   (let [new-tab-id (or (get current-tabs-by-ribbon-id new-ribbon-id)

                        (->> (get entities new-ribbon-id)
                             :ribbon/default-tabs
                             (first))

                        (->> entities
                             (filter (fn [[eid entity]]
                                       (= (:tab/ribbon entity) new-ribbon-id)))
                             (mapv second)
                             (sort-by :common/ord)
                             first
                             :db/id))
         new-db (-> db
                    (assoc-in model/ribbon-id-full-path new-ribbon-id))]
     (merge
      {:db new-db}
      (when new-tab-id
        {:fx [[:dispatch [::open-tab new-tab-id]]]})))))

(rf/reg-event-fx
 ::create-tab-success
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (let [tab (-> resp :body)
         tab-id (:db/id tab)
         new-db (-> db
                    (session-model/merge-entity tab))]
     {:db new-db
      :fx [[:dispatch [::open-tab tab-id]]]})))

(rf/reg-event-fx
 ::create-tab-error
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (js/console.log "Create tab error " resp)
   {:db db}))

(rf/reg-event-fx
 ::open-nev
 [(inject-entities)
  (inject-ribbon-and-tab)
  rf/trim-v]
 (fn [{:keys [db entities ribbon ribbon-id]}
      [{:keys [entity-id entity-type open-in-new-tab?]}]]
   (let [views (->> entities
                    (filterv (fn [[eid entity]]
                               (= (:view/entity-type entity) entity-type)))
                    (mapv second)
                    (remove (fn [{:keys [db/id]}] (string? id))))
         new-view (first views)
         ribbon-temp-tabs (->> entities
                               (filterv (fn [[_ entity]]
                                          (= (:tab/ribbon entity) ribbon-id)))
                               (mapv second)
                               (sort-by :common/ord))
         tab-with-entity-open (->> ribbon-temp-tabs
                                   (filter (fn [tab]
                                             (= (:tab/viewed-entity tab) entity-id)))
                                   (first))]
     (if tab-with-entity-open
       (let [tab-id (:db/id tab-with-entity-open)]
         {:fx [[:dispatch [::open-tab tab-id]]]})

       (let [first-tab-ord (-> ribbon-temp-tabs
                               first
                               :common/ord)
             new-ord (if first-tab-ord
                       (- first-tab-ord 0.001)
                       1)]
         {:db       db
          ::ws/send {:id         :entity/create-entity
                     :body       {:entity/type       :entity.type/tab
                                  :tab/viewed-entity entity-id
                                  :tab/ribbon        ribbon-id
                                  :tab/current-view  (:db/id new-view)
                                  :common/ord        new-ord}
                     :on-success [::create-tab-success]
                     :on-error   [::create-tab-error]}})))))

(rf/reg-event-fx
 ::disable-tab-success
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   {:db db}))

(rf/reg-event-fx
 ::disable-tab-error
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (js/console.log "Disable tab error " resp)))

(rf/reg-event-fx
 ::close-tab
 [rf/trim-v
  (inject-ribbon-and-tab)
  (inject-entities)
  save-tab-id-to-localstorage]
 (fn [{:keys [ribbon-id ribbon entities tab-id]}
      [closed-tab-id]]
   (let [close-current-tab? (= tab-id closed-tab-id)]
     (merge
      {::ws/send {:id         :entity/disable!
                  :body       {:entity-id closed-tab-id}
                  :on-success [::disable-tab-success]
                  :on-error   [::disable-tab-error]}}
      (when close-current-tab?
        (let [closed-tab (get entities closed-tab-id)
              closed-tab-ord (:common/ord closed-tab)
              ribbon-temp-tabs (->> entities
                                    (filterv (fn [[_eid entity]]
                                               (= (:tab/ribbon entity) ribbon-id)))
                                    (mapv second)
                                    (sort-by :common/ord))
              ribbon-default-tabs (->> ribbon
                                       :ribbon/default-tabs
                                       (mapv #(get entities %)))
              next-temp-tab (->> ribbon-temp-tabs
                                 (filterv (fn [{:keys [common/ord]}]
                                            (< closed-tab-ord ord)))
                                 (first))

              prev-temp-tab (->> ribbon-temp-tabs
                                 (filterv (fn [{:keys [common/ord]}]
                                            (< ord closed-tab-ord)))
                                 (last))
              next-tab-id (-> (or next-temp-tab
                                  prev-temp-tab
                                  (first ribbon-default-tabs))
                              :db/id)]
          {:fx [[:dispatch [::open-tab next-tab-id]]]}))))))

(rf/reg-event-fx
 ::create-grid-tab
 standard-intercept
 (fn [{:keys [db ribbon-id entities]}
      [{:keys [entity-type make-default-tab?]}]]
   (let [grid-views-for-entity-type
         (->> entities
              (filterv (fn [[_eid entity]]
                         (and (= (:view/type entity) :view.type/grid)
                              (= (:view/entity-type entity) entity-type))))
              (mapv second))
         view (first grid-views-for-entity-type)
         view-id (:db/id view)]
     {:db       db
      ::ws/send {:id         :entity/create-entity
                 :body       {:entity/type      :entity.type/tab
                              :tab/ribbon       ribbon-id
                              :tab/current-view view-id
                              :common/ord       1}
                 :on-success [::create-tab-success]
                 :on-error   [::create-tab-error]}})))

(rf/reg-event-fx
 ::create-ribbon-success
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (let [ribbon (:body resp)
         ribbon-id (:db/id ribbon)]
     {:db db
      :fx [[:dispatch [::open-ribbon ribbon-id]]
           [:dispatch [::open-add-new-tab-modal]]]})))

(rf/reg-event-fx
 ::create-ribbon-error
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (let []
     (js/console.log "CREATE RIBBON ERROR: " resp)
     {:db db})))

(rf/reg-event-fx
 ::create-ribbon
 [rf/trim-v
  (inject-entities)
  (inject-ribbon-and-tab)]
 (fn [{:keys [db ribbon-id]} [ribbon-name]]
   (let []
     {:db       db
      ::ws/send {:id         :entity/create-entity
                 :body       {:entity/type :entity.type/ribbon
                              :ribbon/name ribbon-name}
                 :on-success [::create-ribbon-success]
                 :on-error   [::create-ribbon-error]}})))

(rf/reg-event-fx
 ::clone-ribbon-success
 standard-intercept
 (fn [{:keys [db]} [resp]]
   (let [entities (-> resp :body :entities)
         ribbon (->> entities
                     (cu/only-entity :entity.type/ribbon)
                     (first))
         entities-by-id (p/index-by :db/id entities)
         new-db (session-model/merge-entities db entities-by-id)]
     {:db new-db
      :fx [[:dispatch [::open-ribbon (:db/id ribbon)]]]})))

(rf/reg-event-fx
 ::clone-ribbon-error
 standard-intercept
 (fn [{:keys [db]} [resp]]
   (js/console.log "clone ribbon error " resp)))

(rf/reg-event-fx
 ::clone-ribbon
 standard-intercept
 (fn [{:keys [db ribbon-id]} [new-ribbon-name]]
   {::ws/send {:id         :ribbon/clone-ribbon
               :body       {:ribbon-name new-ribbon-name
                            :ribbon-id   ribbon-id}
               :on-success [::clone-ribbon-success]
               :on-error   [::clone-ribbon-error]}}))

(rf/reg-event-fx
 ::disable-ribbon-success
 [rf/trim-v]
 (fn [{:keys [db]} [disabled-ribbon-id resp]]
   (let [next-ribbon (->> db
                          (session-model/get-entities)
                          (filterv (fn [[_ entity]]
                                     (and (not= (:db/id entity) disabled-ribbon-id)
                                          (-> entity
                                              :entity/type
                                              (= :entity.type/ribbon)))))
                          (mapv second)
                          (first))]
     (if next-ribbon
       {:fx [[:dispatch [::open-ribbon (:db/id next-ribbon)]]]}
       (js/console.log "Next ribbon not found")))))

(rf/reg-event-fx
 ::disable-ribbon-error
 [rf/trim-v]
 (fn [{:keys [db]} [resp]]
   (js/console.log "Disable ribbon error " resp)
   db))

(rf/reg-event-fx
 ::disable-ribbon
 [rf/trim-v
  (inject-entities)
  (inject-ribbon-and-tab)]
 (fn [{:keys [db]} [disabled-ribbon-id]]
   (let [all-ribbons-count (->> db
                                (session-model/get-entities)
                                (filterv (fn [[eid entity]]
                                           (-> entity :entity/type (= :entity.type/ribbon))))
                                count)]
     (if (< 1 all-ribbons-count)
       {:db       db
        ::ws/send {:id         :ribbon/disable
                   :body       {:ribbon-id disabled-ribbon-id}
                   :on-success [::disable-ribbon-success disabled-ribbon-id]
                   :on-error   [::disable-ribbon-error]}}
       {::show-modal "cannot-delete-last-ribbon-modal"}))))

(rf/reg-event-fx
 ::set-tab-current-view
 standard-intercept
 (fn [{:keys [db tab-id]} [view-id]]
   (let []
     {:db       db
      ::ws/send {:id         :entity/update-attribute
                 :body       {:db/id     tab-id
                              :attribute :tab/current-view
                              :value     view-id}
                 :on-success [::update-tab-success]
                 :on-error   [::update-tab-error]}})))

(rf/reg-event-fx
 ::add-default-tab-success
 standard-intercept
 (fn [{:keys [db ribbon-id]} [resp]]
   (js/console.log "Add default tab success " resp)))

(rf/reg-event-fx
 ::add-default-tab-error
 standard-intercept
 (fn [{:keys [db ribbon-id]} [resp]]
   (js/console.log "Add default tab error " resp)))

(rf/reg-event-fx
 ::make-tab-default-tab
 standard-intercept
 (fn [{:keys [db ribbon-id]} [tab-id]]
   (let []
     {:db       db
      ::ws/send {:id         :ribbon/add-default-tab
                 :body       {:ribbon-id ribbon-id
                              :tab-id    tab-id}
                 :on-success [::add-default-tab-success]
                 :on-error   [::add-default-tab-error]}})))

(rf/reg-event-fx
 ::demote-tab-success
 standard-intercept
 (fn [{:keys [db]} [resp]]
   (js/console.log "DEMOTE SUCCESS " resp)))

(rf/reg-event-fx
 ::demote-tab-error
 standard-intercept
 (fn [{:keys [db]} [resp]]
   (js/console.log "DEMOTE ERROR " resp)))

(rf/reg-event-fx
 ::demote-tab-from-default-tabs
 standard-intercept
 (fn [{:keys [db ribbon-id]} [tab-id]]
   {::ws/send {:id         :ribbon/demote-default-tab
               :body       {:ribbon-id ribbon-id
                            :tab-id    tab-id}
               :on-success [::demote-tab-success]
               :on-error   [::demote-tab-error]}}))

(rf/reg-event-fx
 ::update-tab-success
 standard-intercept
 (fn [{:keys [db]} [resp]]))

(rf/reg-event-fx
 ::update-tab-error
 standard-intercept
 (fn [{:keys [db]}]))

(rf/reg-event-fx
 ::update-tab
 standard-intercept
 (fn [{:keys [db]} [{:keys [tab-id field value]}]]
   (let []
     {:db       db
      ::ws/send {:id         :entity/update-attribute
                 :body       {:db/id     tab-id
                              :attribute field
                              :value     value}
                 :on-success [::update-tab-success]
                 :on-error   [::update-tab-error]}})))

(rf/reg-fx
 ::show-modal
 (fn [modal-id]
   (if-let [el (oops/ocall js/document "getElementById" modal-id)]
     (oops/ocall el "showModal")
     (js/console.log "Modal element not found: " modal-id))))

(rf/reg-event-fx
 ::open-create-ribbon-modal
 standard-intercept
 (fn [{:keys [db]}]
   {::show-modal "create-ribbon-modal"}))

(rf/reg-event-fx
 ::open-clone-ribbon-modal
 standard-intercept
 (fn [_]
   {::show-modal "clone-ribbon-modal"}))

(rf/reg-event-fx
 ::open-add-new-tab-modal
 standard-intercept
 (fn [_]
   {::show-modal "add-new-tab-modal"}))
